import React, { useState, useEffect } from 'react';
import {
  Box,
  Table,
  TableCell,
  TableRow,
  TableSortLabel,
} from '@mui/material';

import Loader from '@components/Loader';
import * as S from './styles';

type tableCell = { [key: string]: string | number | JSX.Element };

interface Props {
  headRows: tableCell[];
  errorRowIds: [];
  isSus: boolean;
  genderArr: [];
  bodyRows: tableCell[] | null;
  selectedRowId: string | null;
  disabledRowIds: string[] | null;
  sorting: {
    sort: string | undefined,
    onChangeSorting: (params: string) => void,
  };
}

const DefaultTable = ({ headRows, bodyRows, selectedRowId, sorting, errorRowIds, isSus }: Props) => {
  const { sort = '', onChangeSorting } = sorting;

  const [orderState, setOrderState] = useState({
    order: 'asc',
    orderBy: '',
  });

  useEffect(() => {
    if (sort) {
      const isDesc = sort[0] === '-';
      setOrderState({
        order: isDesc ? 'desc' : 'asc',
        orderBy: isDesc ? sort.slice(1) : sort,
      });
    }
  }, [sort]);

  useEffect(() => {
    const sortParams = `${orderState.order === 'desc' ? '-' : ''}${orderState.orderBy}`;
    if (orderState.orderBy && sortParams !== sort) {
      onChangeSorting(sortParams);
    }
  }, [orderState.order, orderState.orderBy]);

  const onSort = (columnKey: string): void => {
    const column = columnKey;

    const isAsc = orderState.orderBy === column && orderState.order === 'asc';
    setOrderState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: column,
    });
  };

  const renderRows = () => bodyRows?.length ? (
    bodyRows.map((row) => (
      <TableRow key={`${row.id}`} hover={true} selected={selectedRowId === row.id} className={`${errorRowIds?.includes(row.id) ? 'error' : ''} ${isSus && row.gender?.props?.children === 'Männlich' && 'blue'} ${isSus && row.gender?.props?.children !== 'Männlich' && 'rose'}`}>
        {headRows.map((el) => (
          <TableCell
            key={`${el.key}`}
            style={{ width: `${el.width}` }}
          >
            {row[`${el.key}`]}
          </TableCell>
        ))}
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell sx={{ borderRadius: '0 0 14px 14px !important' }} colSpan={headRows.length}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          No data found
        </Box>
      </TableCell>
    </TableRow>
  );

  const checkSortDirection = (headerKey: string) => {
    return orderState.orderBy.split('.')[0] === headerKey ? orderState.order : 'asc';
  };

  return (
    <S.TableWrapper>
      <S.TableInner>
        <S.StyledTableContainer>
          <Table size={'medium'} stickyHeader>
            <S.StyledTableHead>
              <TableRow>
                {headRows.map((headCell) => (
                  <TableCell
                    key={`${headCell.key}`}
                    component='th'
                  >
                    {headCell.sortable ? (
                      <TableSortLabel
                        active={orderState.orderBy.split('.')[0] === headCell.key}
                        direction={checkSortDirection(headCell.key)}
                        onClick={() => onSort(`${headCell.key}`)}
                      >
                        {headCell.title}
                        {orderState.orderBy.split('.')[0] === headCell.key && (<Box component="span" />)}
                      </TableSortLabel>
                    ) : headCell.title}
                  </TableCell>)
                )}
              </TableRow>
            </S.StyledTableHead>

            <S.StyledTableBody>

              {!bodyRows ? (
                <TableRow>
                  <TableCell colSpan={headRows.length}>
                    <Loader />
                  </TableCell>
                </TableRow>
              ) : renderRows()}

            </S.StyledTableBody>
          </Table>
        </S.StyledTableContainer>
        {bodyRows && (
          <S.TableFooter>

          </S.TableFooter>
        )}
      </S.TableInner>
    </S.TableWrapper>
  );
};

export default DefaultTable;
